<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name=""
          @click="submit"
        >設定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">絞り込みの設定</span>
        </div>
        <div class="popup-content">
          <div class="list01">
            <ul class="list01-list">
              <li class="list01-item">
                <div class="label">
                  <div class="formparts checkbox">
                    <input type="checkbox" value="qa" id="cb_02_01" v-model="data.filterTypes">
                    <label role="button" for="cb_02_01">Q&A・事例<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </li>
              <li class="list01-item">
                <div class="label">
                  <div class="formparts checkbox">
                    <input type="checkbox" value="knowledge" id="cb_02_02" v-model="data.filterTypes">
                    <label role="button" for="cb_02_02">最新ナレッジ<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </li>
              <!-- 検索履歴の時だけ以下を表示 -->
              <li class="list01-item" v-if="$route.name === 'SPHistoryOfSearch'">
                <div class="label">
                  <div class="formparts checkbox">
                    <input type="checkbox" value="note" id="cb_02_03" v-model="data.filterTypes">
                    <label role="button" for="cb_02_03">ノート<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </li>
              <li class="list01-item">
                <div class="label">
                  <div class="formparts checkbox">
                    <input type="checkbox" value="pj" id="cb_02_04" v-model="data.filterTypes">
                    <label role="button" for="cb_02_04">資料<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    type: {
      default: 'searchHistory'
    }
  },
  setup (props, context) {
    const route = context.root.$route
    const store = context.root.$store
    const { searchHistory, searchCondition } = store.state

    // TODO: 他ページでの流用時、以下調整
    const data = reactive({
      filterTypes: route.name === 'SPHistoryOfSearch'
        ? searchHistory.filterTypes
        : searchCondition.filterTypes
    })

    const close = () => {
      context.emit('closeSearchConditionExtract')
    }
    const submit = () => {
      // TODO: 他ページでの流用時、以下調整
      if (route.name === 'SPHistoryOfSearch') {
        store
          .dispatch('searchHistory/changeFilterTypes', data.filterTypes)
          .then(() => {
            store.dispatch('searchHistory/getLists')
          })
      } else {
        store
          .dispatch('searchCondition/setFilterTypes', data.filterTypes)
          .then(() => {
            store.dispatch('searchCondition/resetLists')
          })
      }

      context.emit('submitSearchConditionExtract')
      context.emit('closeSearchConditionExtract')
    }

    return {
      data,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
